export const LoginInitialValues = {
  email: "",
  password: "",
};

export const AdminUserModalInitialsValue = {
  dateFormat: "",
};

export const EditUserInitialValues = {
  firstName: "",
  lastName: "",
  email: "",
  status: null,
  userRole: "",
};

export const roleInitialValues = {
  name: "",
  permissionIds: [],
};
